module.exports = __webpack_public_path__ + "img/mapIcon.c9789f47.svg";